import MarkdownRender from 'LuxKit/MarkdownRender'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import TextLink from 'LuxKit/TextLink'
import Expander from 'components/utils/Expander'
import useToggle from 'hooks/useToggle'
import { sum } from 'lib/array/arrayUtils'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

const MAX_SHORT_CHARS = 500

const Description = styled(MarkdownRender)`
  & > h4 + p {
    margin-top: ${rem(8)};
  }
`

const ExpandedDescription = styled(MarkdownRender)`
  margin-top: ${rem(8)};

  & > h4 + p {
    margin-top: ${rem(8)};
  }
`

const ToggleLink = styled(TextLink)`
  margin-top: ${rem(8)};
`

interface Props {
  description: string
}

function OfferDetailDescription({ description }: Props) {
  const intl = useIntl()
  const [expanded, toggleExpanded] = useToggle()

  const [shortDescription, expandedDescription] = useMemo(() => {
    const short = description.split('\n').reduce<Array<string>>((acc, value) => {
      if (sum(acc, acc => acc.length) < MAX_SHORT_CHARS) {
        acc.push(value)
      }
      return acc
    }, []).join('\n')
    return [short, description.replace(short, '').trim()]
  }, [description])

  const readMoreLabel = intl.formatMessage({
    id: 'kh_qYG_H62xNrLsmRyRO',
    defaultMessage: 'Read more',
    description: 'Button to expand hotel description text on the hotel or room booking page',
  })

  const readLessLabel = intl.formatMessage({
    id: '5UFaFQ7weA2pEK19Rmvx',
    defaultMessage: 'Read less',
    description: 'Action button to collapse hotel description text in the trip planner AI chat',
  })

  return (
    <div>
      <Description type="compact" fontSize="medium" content={shortDescription} />
      {expandedDescription && <>
        <Expander expanded={expanded}>
          <ExpandedDescription type="compact" fontSize="medium" content={expandedDescription} />
        </Expander>
        <ToggleLink
          size="medium"
          endIcon={<DropdownChevron direction={expanded ? 'up' : 'down'} />}
          onClick={toggleExpanded}
        >
          {expanded ? readLessLabel : readMoreLabel}
        </ToggleLink>
      </>}
    </div>
  )
}

export default OfferDetailDescription
